export default "__VITE_ASSET__hS8VF$sW__"